var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExercise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2685_9783",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2685_9783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4582 15.0416L25.3749 4.95829L26.0832 4.24996C26.7221 3.61107 27.5138 3.29857 28.4582 3.31245C29.4027 3.32634 30.1943 3.65273 30.8332 4.29162L36.2082 9.66662C36.8471 10.3055 37.1665 11.0902 37.1665 12.0208C37.1665 12.9513 36.8471 13.7361 36.2082 14.375L35.4582 15.0416ZM14.9165 35.6666C14.2777 36.3055 13.4929 36.625 12.5624 36.625C11.6318 36.625 10.8471 36.3055 10.2082 35.6666L4.83321 30.2916C4.19432 29.6527 3.87488 28.868 3.87488 27.9375C3.87488 27.0069 4.19432 26.2222 4.83321 25.5833L5.49988 24.9166L15.5832 35L14.9165 35.6666ZM20.9582 34.5C20.6249 34.8333 20.236 35 19.7915 35C19.3471 35 18.9582 34.8333 18.6249 34.5L5.99988 21.875C5.66654 21.5416 5.49988 21.1527 5.49988 20.7083C5.49988 20.2638 5.66654 19.875 5.99988 19.5416L8.37488 17.125C8.70821 16.7916 9.10404 16.625 9.56238 16.625C10.0207 16.625 10.4165 16.7916 10.7499 17.125L13.3749 19.75L20.2915 12.8333L17.6665 10.2083C17.3332 9.87495 17.1665 9.48607 17.1665 9.04162C17.1665 8.59718 17.3332 8.20829 17.6665 7.87496L20.0415 5.45829C20.3749 5.12495 20.7707 4.95829 21.229 4.95829C21.6874 4.95829 22.0832 5.12495 22.4165 5.45829L35.0415 18.0833C35.3749 18.4166 35.5415 18.8125 35.5415 19.2708C35.5415 19.7291 35.3749 20.125 35.0415 20.4583L32.6249 22.8333C32.2915 23.1666 31.9027 23.3333 31.4582 23.3333C31.0138 23.3333 30.6249 23.1666 30.2915 22.8333L27.6665 20.2083L20.7499 27.125L23.3749 29.75C23.7082 30.0833 23.8749 30.4791 23.8749 30.9375C23.8749 31.3958 23.7082 31.7916 23.3749 32.125L20.9582 34.5Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExercise);
export default __webpack_public_path__ + "static/media/exercise.6f320d16.svg";
export { ForwardRef as ReactComponent };